if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('panel', {
  schema: {
    width: { type: 'number', default: 0.75 },
    height: { type: 'number', default: 0.5 },
    copy: { type: 'string', default: '#panel-chime' },
  },

  init: function() {
    var data = this.data;
    var el = this.el;

    el.setAttribute('geometry', `primitive: plane; height: ${data.height}; width: ${data.width};`);
    el.setAttribute('material', `transparent: true; opacity:1; color:#fff; src:${data.copy};`);

  },
  play: function () {
  },
  update: function (oldData) {
  },
});


// WEBPACK FOOTER //
// ./src/aframe/components/panel.js